// HOOKS
import { useState, useRef, useEffect } from "react";

// COMPONENTS
import { ReactComponent as ExpandIcon } from "../../../assets/icons/expandDown.icon.svg";
import CustomizableSearch from "../../tables/customizableTable/features/search/search";

const DEFAULT_CLASSNAMES = {
  td: "w-full",
  select: "w-full font-ubuntuRegular shadow h-[36px] text-center p-1 rounded",
};

const DEFAULT_OPTIONS = [
  { value: "default", label: "DEFAULT", id: 1 },
  { value: "test", label: "Test", id: 2 },
];
const DEFAULT_VALUE = "DEFAULT";

const TableSearchSelection = ({
  classNames = DEFAULT_CLASSNAMES,
  value = DEFAULT_VALUE,
  options = DEFAULT_OPTIONS,
  onChange = () => {},
  handleSearch = () => {},
  parentId,
  name, // Field that is shown
  ...otherProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });
  return (
    <td className={classNames.td}>
      <div
        tabIndex={0}
        ref={ref}
        className={`${
          isOpen && "border-animate"
        } w-full min-h-[36px] h-full font-ubuntuMedium bg-white shadow rounded outline-none gap-[.5em] p-[.2em] flex items-center focus:border focus:shadow-primary relative`}
      >
        <div className="w-full h-full flex flex-row justify-between items-center">
          <span className="flex items-center justify-center w-full">
            {value && (
              <div className="text-center cursor-pointer bg-slate-100 text-secondary rounded px-2 py-1 flex gap-2">
                <span>{value}</span>
              </div>
            )}
          </span>
          <div className="flex w-content items-center h-full">
            <ExpandIcon
              onClick={() => setIsOpen(!isOpen)}
              className={`${
                isOpen && "fill-primary"
              } cursor-pointer flex items-center hover:fill-primary min-w-4 min-h-4 w-6 h-4`}
            />
          </div>
        </div>
        <div
          style={{ top: "calc(100% + .25em)" }}
          className={`${
            isOpen ? "" : "hidden"
          } flex flex-col gap-1 shadow-lg z-20 pt-1 px-2 backdrop-blur-sm bg-greenGlass absolute left-0 w-content rounded m-0 p-0 list-none max-h-[15em] overflow-y-auto`}
        >
          <div className="flex flex-col p-2 bg-slate-100 shadow-black shadow-sm">
            <CustomizableSearch onSearch={handleSearch} />
          </div>
          <ul className="p-1">
            {options.map((option) => (
              <li
                key={option.id}
                data-id={option.id}
                data-parent_id={parentId}
                data-name={name}
                onClick={onChange}
                className={`text-center bg-white shadow-black shadow m-1 cursor-pointer hover:bg-primary hover:text-secondary rounded px-2 py-2"`}
              >
                {option?.[name]}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </td>
  );
};

export default TableSearchSelection;
